module.exports = __webpack_public_path__ + "img/lastModel1.0e5293c7.png";